module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/logo-venturebeat.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/logo-venturebeat.png
// module id = 1218
// module chunks = 0